/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { GovernmentEndorsements } from './GovernmentEndorsements';

export class DriverGovernmentEndorsement extends GovernmentEndorsements {
    driverGovernmentEndorsementId:number;
    driverId:number;
    expirationDate:string;
    dateValidated: string;
    licenseType: string;
    licenseTypeId: number;
}
